<template>
  <Modal class-name="vertical-center-modal" v-model="show" :mask-closable="false">
    <div slot="header" class="modal-header">添加白名单用户</div>
    <Select
      :key="n"
      ref="selectOptions"
      class="item-width remote" 
      filterable
      remote
      v-model="uid"
      :remote-method="remoteMethod"
      :loading="searchLoading"
      :placeholder="'输入手机号查询'"> 
      <Option v-if="this.list.length === 0" value="" disabled>无匹配数据项</Option>   
      <Option v-for="item in list" :value="item.uid" :key="item.uid">{{item.userPhone}}</Option>
    </Select>

    <div slot="footer">
      <div>
        <Button type="text" size="large" @click="close">取消</Button>
        <Button type="primary" size="large" @click="save" :loading="loading" >
          <span v-if="!loading" >保存</span>
          <span v-else>保存中...</span>
        </Button>
      </div>  
    </div>

  </Modal>
</template>

<script type="text/ecmascript-6">
import { getUid,addSpecialRules } from '@/api/managementCenter'
export default {
  props:{
    n:{
      type:Number,
      default:0
    }
  },
  watch:{
    n(val) {
      this.show = true
    
       this.list = []
      this.uid = null
      this.userPhone = '' 
      this.userName = ''
    }
  },
  
  data() {
    return {
      loading:false,
      searchLoading:false,
      show: false,
      showSelect:false,
      uid:null,
      userPhone:'',
      userName:'',
      list:[]
    }
  },
  methods:{
    close(){
      this.show = false
       this.showSelect = false
    },
    remoteMethod(query){
      let pattern = /^1\d{10}$/
       if(pattern.test(query)) {
         this.searchLoading= true
         // 调接口
         getUid(query).then( res => {
           this.searchLoading= false
           this.userName = res.data.userName
           this.userPhone = res.data.userPhone
           this.list.splice(0)
           this.list.push(res.data)
         })
       }else {
          this.searchLoading = false
       }
      
    },
    save() {
    // 调接口
    if(!this.uid || !this.userPhone) {
      this.$Message.error('请输入手机号！')
      return
    }
    this.loading = true
    let data = {
      ruleType: 1,
      uid: this.uid,
      userPhone: this.userPhone,
      userName : this.userName
    }
    addSpecialRules(data).then( res => {
      this.loading = false
      this.$Message.success('添加成功！')
      this.show = false
      this.$emit('refresh')
    }).catch( err => {
      this.loading = false
      console.log(err)
    })
    }

  }
}
</script>
